import BindingStatusBadge from "@/components/screenbindings/BindingStatusBadge";
import OriginBadge from "@/components/screenbindings/OriginBadge";
import { operationLabel, OPERATION_META, statusMeta } from "@/lib/screenBindings";
import { stepTarget } from "@/lib/screenWalkthrough";

/** Iter 47 / 48 — one observed (or consultant-supplied) screen statement in the ordered list. */
export default function StepCard({ step, selected, onSelect }) {
  const m = statusMeta(step.status);
  const t = step.field_totals || {};
  return (
    <button
      type="button"
      onClick={() => onSelect(step)}
      className={`w-full text-left ml-card px-4 py-3 hover:border-[var(--ml-primary)] transition-colors ${selected ? "border-[var(--ml-primary)] bg-[var(--ml-primary)]/5" : step.manual ? "border-[#ffb3b8]" : ""}`}
      data-testid={`sw-step-${step.sequence_number}`}
      data-status={step.status}
      data-operation={step.operation}
      data-confidence={step.confidence}
      data-origin={step.manual ? "manual" : "parser"}
      aria-pressed={selected}
    >
      <div className="flex items-start gap-3">
        <div className="ml-mono text-2xl font-semibold tabular-nums leading-none w-8 shrink-0 text-[var(--ml-primary)]" data-testid={`sw-step-seq-${step.sequence_number}`}>
          {step.sequence_number}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <span className="ml-mono text-xs font-semibold" title={(OPERATION_META[step.operation] || {}).hint}>{operationLabel(step.operation)}</span>
            <span className="ml-mono text-sm font-semibold" data-testid={`sw-step-target-${step.sequence_number}`}
              style={step.status === "bound" ? undefined : { color: m.fg }}>
              {stepTarget(step)}
            </span>
            <BindingStatusBadge status={step.status} confidence={step.confidence} testid={`sw-step-status-${step.sequence_number}`} />
            {step.manual && <OriginBadge origin="manual" compact testid={`sw-step-origin-${step.sequence_number}`} />}
          </div>
          <div className="text-[11px] text-[var(--ml-text-secondary)] mt-1 flex flex-wrap gap-x-3">
            <span>{step.program_library ? `${step.program_library}/` : ""}{step.program_name}</span>
            <span>display file {step.display_file || "—"}</span>
            <span>format {step.record_format}</span>
            <span>{step.source_line != null ? `line ${step.source_line}` : "no source line"}</span>
            {step.status === "bound" && (
              <span data-testid={`sw-step-fields-${step.sequence_number}`}>
                <strong style={{ color: "#0043ce" }}>{t.input || 0} input</strong> · {(t.output || 0) + (t.display || 0)} output/display · {t.proven_mappings || 0} proven · {t.ambiguous_mappings || 0} ambiguous
              </span>
            )}
            {step.status !== "bound" && <span style={{ color: m.fg }}>{m.wording}</span>}
          </div>
          {step.manual && (
            <div className="text-[11px] mt-1 text-[#a2191f]" data-testid={`sw-step-manual-${step.sequence_number}`}>
              Manual binding · consultant supplied · not parser-proven{step.source_line == null ? " · position not observed in source" : " — display file supplied by consultant for this observed statement"}
            </div>
          )}
          {step.source_excerpt && (
            <pre className="text-[11px] ml-mono mt-1.5 truncate text-[var(--ml-text-secondary)]" data-testid={`sw-step-excerpt-${step.sequence_number}`}>{step.source_excerpt.trim()}</pre>
          )}
        </div>
      </div>
    </button>
  );
}
